
const UnknownUser = () => {


  return (
    <div className="error-container" data-testid="unknown-user">
        <h1>Nous ne vous avons pas reconnu... 😢</h1>
        <p>Authentifiez-vous d'abord sur <a href='https://loc-hall.fr/'>Loc'Hall</a> puis revenez-nous voir.</p>
        <p>A tout de suite 👋</p>
    </div>
  );
};

export default UnknownUser;
